"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _helpers_1 = require("../../helpers");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ModalContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  min-height: 100vh;\n  z-index: 1000;\n  padding: 30px;\n  @media (max-width: ", ") {\n    padding: 0;\n    height: ", ";\n    overflow: hidden;\n    .styledQuestionnaireCard {\n      height: ", ";\n    }\n  }\n"], ["\n  background: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  min-height: 100vh;\n  z-index: 1000;\n  padding: 30px;\n  @media (max-width: ", ") {\n    padding: 0;\n    height: ", ";\n    overflow: hidden;\n    .styledQuestionnaireCard {\n      height: ", ";\n    }\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (props) { return props.theme.breakpointMobile; }, function (_a) {
    var fullVH = _a.fullVH;
    return "max(" + fullVH + ", 100vh)";
}, function (_a) {
    var fullVH = _a.fullVH;
    return fullVH;
});
var CloseIcon = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1001;\n  background: #fff;\n  padding: 5px;\n  i {\n    font-size: 40px;\n    color: ", ";\n    margin: 0;\n    cursor: pointer;\n  }\n  @media (max-width: ", ") {\n    i {\n      color: #000;\n      font-size: 30px;\n    }\n  }\n"], ["\n  display: flex;\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1001;\n  background: #fff;\n  padding: 5px;\n  i {\n    font-size: 40px;\n    color: ", ";\n    margin: 0;\n    cursor: pointer;\n  }\n  @media (max-width: ", ") {\n    i {\n      color: #000;\n      font-size: 30px;\n    }\n  }\n"])), function (_a) {
    var color = _a.color, dark = _a.dark, theme = _a.theme;
    return _helpers_1.setFontColor(dark, color, theme);
}, function (props) { return props.theme.breakpointMobile; });
var Modal = function (_a) {
    var showModal = _a.showModal, children = _a.children, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'rgba(0, 0, 0, 0.25)' : _b, _c = _a.padding, padding = _c === void 0 ? '30px' : _c, _d = _a.dark, dark = _d === void 0 ? false : _d, _e = _a.showCloseButton, showCloseButton = _e === void 0 ? true : _e, closeModal = _a.closeModal;
    var fullVH = _helpers_1.use100vh();
    react_1.useEffect(function () {
        if (showModal) {
            document.documentElement.classList.add('is-clipped');
            document.documentElement.classList.add('modal-open');
            document.documentElement.classList.remove('modal-closed');
        }
        else {
            document.documentElement.classList.remove('is-clipped');
            document.documentElement.classList.remove('modal-open');
            document.documentElement.classList.add('modal-closed');
        }
    }, [showModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null, showModal && (react_1.default.createElement(ModalContainer, { padding: padding, backgroundColor: backgroundColor, fullVH: fullVH ? fullVH + "px" : '100vh' },
        showCloseButton && (react_1.default.createElement(CloseIcon, { id: "close-modal", className: "has-text-right", dark: dark, onClick: closeModal },
            react_1.default.createElement("i", { className: "material-icons" }, "close"))),
        children))));
};
exports.default = Modal;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.js.map